import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const FormAddCompany = () => {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [fax, setFax] = useState("");
  const [file, setFile] = useState("");
  const [preview, setPreview] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  // Access the environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  const loadImage = (e) => {
    const image = e.target.files[0];
    setFile(image);
    setPreview(URL.createObjectURL(image));
  };

  const saveCompany = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", name);
    formData.append("address", address);
    formData.append("fax", fax);
    formData.append("email", email);
    formData.append("phone", phone);
    try {
      await axios.post(`${API_BASE_URL}/companies`, formData, {
        headers: {
          "Content-type": "multipart/form-data",
          'X-API-Key': API_KEY
        },
      });
      navigate("/companies");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };
  return (
    <div className="container">
      <div className="columns">
        <div className="column is-centered">
          <h1 className="title is-size-5">Create Company</h1>
          <div className="card is-shadowless">
            <form onSubmit={saveCompany}>
              <p className="has-text-centered">{msg}</p>
              <div className="field">
                <label className="label">Name</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Name"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Address</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Address"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Email</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Phone</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Phone"
                  />
                </div>
              </div>                 
              <div className="field">
                <label className="label">Fax</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={fax}
                    onChange={(e) => setFax(e.target.value)}
                    placeholder="Fax"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Logo</label>
                <div className="control">
                  <div className="file">
                    <label className="file-label">
                      <input
                        type="file"
                        className="file-input"
                        onChange={loadImage}
                      />
                      <span className="file-cta">
                        <span className="file-label">Choose a file...</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              {preview ? (
                <figure className="image is-128x128">
                  <img src={preview} alt="Preview Image" />
                </figure>
              ) : (
                ""
              )}
              <div className="field">
                <div className="control">
                  <Link to="/companies">
                  <button className="button is-small is-warning mr-1">
                    Cancel
                  </button>
                  </Link>
                  <button type="submit" className="button is-small is-success">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormAddCompany;
